import React from 'react';
import { Tag, Tooltip } from 'antd';

import { isPendingIntake } from '../../services/records';

/**
 * "Needs review": this item came in through an intake link from someone
 * WITHOUT an account, and nobody here has accepted it yet.
 *
 * Not decoration. A submission can carry a stranger's links, addresses and
 * rich text, and without the tag a reader clicks them believing a colleague
 * typed them. It sits first among the state tags, because it is the thing to
 * know before reading anything else on the record. Renders nothing for any
 * other item, so every surface can drop it in unconditionally.
 */
export default function IntakePendingTag({ item, className = '' }) {
	if (!isPendingIntake(item)) return null;
	const via = item?.intake?.linkName ? `the “${item.intake.linkName}” intake link` : 'an intake link';
	return (
		<Tooltip title={`Sent through ${via} by someone without an account. Nobody has reviewed it yet.`}>
			<Tag color="volcano" className={['intake-pending-tag', className].filter(Boolean).join(' ')} data-testid="intake-pending-tag">
				Needs review
			</Tag>
		</Tooltip>
	);
}
